<template>
  <div class="app-wrap">
    <div :span="24" class="h100 overflow-x-y" style="overflow-y: auto; background: #f6f6f6">
      <!-- 搜索框 start -->
      <div class="search padding24">
        <el-form :inline="true" class="flex-alignend" :model="searchForm" @submit.native.prevent>
          <!--历史日志start-->
          <!-- <el-form-item>
            <el-select
              :placeholder="$t('logs.searchInputHistoryLog')"
              style="width: 320px"
              v-model.trim="searchForm.history"
              clearable
            ></el-select>
          </el-form-item> -->
          <!--历史日志end-->
          <!--登录ip Start-->
          <el-form-item>
            <el-input
              v-model.trim="searchForm.remoteIp"
              :placeholder="$t('logs.searchInputLoginAddress')"
              style="width: 320px"
              clearable
            ></el-input>
          </el-form-item>
          <!--登录ip end-->
          <!--操作人start-->
          <el-form-item>
            <el-select
              v-model.trim="searchForm.operator"
              v-loadmore="userLoadMore"
              :placeholder="$t('logs.searchOperatorPlaceholder')"
              style="width: 320px"
              remote
              filterable
              clearable
              value-key="id"
              :remote-method="userRemoteMethod"
              @visible-change="userFocus"
              @change="userchange"
            >
              <template v-for="item in userTableData">
                <el-option
                  v-show="!item.hidden"
                  :key="item.id"
                  :label="`${item.displayName}(${item.username})`"
                  :value="item"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <!--操作人end-->
          <!--操作类型start-->
          <el-form-item v-if="showSearchMore" label-width="100px" class="padding-right25">
            <el-select v-model="searchForm.logTypes" clearable placeholder="请选择操作类型">
              <el-option
                v-for="item in loginType"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <!--操作类型end-->
          <!--操作状态start-->
          <el-form-item
            v-if="showSearchMore"
            prop="dictPermission"
            label-width="100px"
            class="padding-right25"
          >
            <el-select v-model="searchForm.requestState" clearable placeholder="请选择操作状态">
              <el-option
                v-for="item in operateStatus"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <!--操作状态end-->
          <!--开始结束时间start-->
          <el-form-item v-if="showSearchMore">
            <el-date-picker
              v-model="searchForm.timeArray"
              type="daterange"
              :range-separator="$t('logs.searchInputTimeContact')"
              :start-placeholder="$t('logs.searchInputStartTime')"
              :end-placeholder="$t('logs.searchInputEndTime')"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <!--开始结束时间end-->
          <el-form-item>
            <!-- 查询按钮 -->
            <el-button type="primary" class="search-btn" @click="handleSearch()">
              {{ $t("logs.searchBtnConfirmText") }}
            </el-button>
            <!-- 重置按钮 -->
            <el-button class="reset-btn" @click="handleResetSearch()">
              {{ $t("logs.searchBtnResetText") }}
            </el-button>
            <!-- 高级和普通搜索切换 -->
            <el-button style="color: #505363" type="text" @click="showSearchMore = !showSearchMore">
              {{
                !showSearchMore ? $t("logs.searchBtnSeniorText") : $t("logs.searchBtnNormalText")
              }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 搜索框 end-->
      <!-- 主题内容 start -->
      <div class="content-wrap padding24">
        <!-- 表格上方内容 start -->
        <div class="content-table-top">
          <div class="content-table-top-title">
            <span class="vertical-bar fn18 fnM">{{ $t("logs.loginLog") }}</span>
          </div>
          <!-- <div class="content-table-top-export">
            <el-button class="export-btn" type="primary">
              <svg-icon icon-class="export" class="export-icon"></svg-icon>
              {{ $t("logs.exportLog") }}
            </el-button>
          </div> -->
        </div>
        <!-- 表格上方内容 end -->

        <!-- 表格内容start-->
        <CustomTable
          ref="customTable"
          :loading="loading"
          :table-data="tableData"
          :pagination="pagination"
          @handleSizeChange="handlePaginationChange"
          @handleCurrentChange="handlePaginationChange"
        >
          <el-table-column width="100" prop="operator" :label="$t('logs.operator')" />
          <el-table-column
            width="120"
            prop="remoteIp"
            :label="$t('logs.loginIp')"
          ></el-table-column>
          <el-table-column
            width="100"
            :show-overflow-tooltip="true"
            prop="loginMethod"
            :label="$t('logs.loginMethod')"
          />
          <el-table-column
            width="100"
            :show-overflow-tooltip="true"
            prop="browser"
            :label="$t('logs.browser')"
          />
          <el-table-column
            width="100"
            :show-overflow-tooltip="true"
            prop="os"
            :label="$t('logs.operateSystem')"
          />
          <el-table-column width="100" prop="logType" :label="$t('logs.loginType')" />
          <el-table-column width="100" prop="requestState" :label="$t('logs.loginStatus')">
            <template slot-scope="scope">
              <log-status :status="scope.row.requestState === 'SUCCEED' ? 'success' : 'danger'">
                {{ transStatus(scope.row.requestState) }}
              </log-status>
            </template>
          </el-table-column>
          <el-table-column
            prop="logContent"
            show-overflow-tooltip
            :label="$t('logs.logInformation')"
          ></el-table-column>
          <el-table-column width="180" prop="createTime" :label="$t('logs.loginTime')" />
          <!-- <el-table-column :label="$t('public.operation')" width="100">
            <template slot-scope="scope">
              <el-button class="cursor-p" @click="handleShowLogsDetails(scope.row)" type="text">
                {{ $t("common.view") }}
              </el-button>
            </template>
          </el-table-column> -->
        </CustomTable>
        <!-- 表格内容end-->
      </div>
      <!-- 主题内容 end -->
      <!-- 详情start -->
      <log-details-dialog
        :visible.sync="detailsFlag"
        :dialog-data="logDetails"
        @success="handleUpdateList"
      />
      <!-- 详情end-->
    </div>
  </div>
</template>

<script>
import LogDetailsDialog from "../components/log-details-dialog";
import LogStatus from "../components/log-status";
import { getDictionary } from "@/api/common";
import userApi from "@/api/user/user";
import LogsApi from "@/api/logs";
import { mapGetters } from "vuex";
// 初始化查询条件
function initSearchParams() {
  return {
    remoteIp: "",
    operator: "",
    userUuid: "",
    userName: "",
    timeArray: [],
    requestState: "",
    logTypes: "" // 类型
  };
}
export default {
  name: "LogLoginList",
  components: {
    LogDetailsDialog,
    LogStatus
  },
  props: {
    isInit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["tenantId"])
  },
  data() {
    return {
      searchForm: {
        remoteIp: "",
        operator: "",
        timeArray: [],
        requestState: "",
        logTypes: "" // 类型
      },
      operateType: [],
      operateStatus: [],
      loginType: [
        { name: "登录", code: "LOGIN" },
        { name: "退出", code: "LOGOUT" }
      ],
      loading: false,
      detailsFlag: false,
      logDetails: {},
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      tableData: [],
      showSearchMore: false,
      userTableData: [],
      userPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  created() {
    // 1.获取列表数据2.获取操作类型字典3.获取操作状态字典
    this.startSearch();
    this.getOperateType();
    this.getOperateStatus();
    this.getTree();
  },

  methods: {
    // 获取列表数据
    startSearch() {
      this.loading = true;
      const [startDate, endDate] = this.searchForm.timeArray;
      const logTypes = this.searchForm.logTypes ? this.searchForm.logTypes : "LOGIN,LOGOUT";
      const parmas = {
        size: this.pagination.pageSize,
        page: this.pagination.pageNum,
        logTypes,
        startDate: startDate || "",
        endDate: endDate || "",
        "orders[0].asc": "false",
        "orders[0].column": "createTime"
      };
      if (this.searchForm.remoteIp) {
        parmas.remoteIp = this.searchForm.remoteIp;
      }
      if (this.searchForm.userUuid) {
        parmas.createBy = this.searchForm.userUuid;
      }
      if (this.searchForm.requestState) {
        parmas.requestState = this.searchForm.requestState;
      }
      LogsApi.getLogsList(parmas).then(res => {
        this.loading = false;
        const { data } = res;
        if (data) {
          const { records = [], total = 0 } = data;
          this.tableData = records;
          this.tableData.forEach(element => {
            const userAgentParse = element["userAgentParse"];
            if (userAgentParse) {
              const browser = userAgentParse["browser"]["name"];
              const os = userAgentParse["os"]["name"];
              const mobile = userAgentParse["mobile"] ? "手机" : "PC";
              let logType = element["logType"];
              logType = logType === "LOGIN" ? "登录" : "退出";

              element["browser"] = browser;
              element["os"] = os;
              element["loginMethod"] = mobile;
              element["logType"] = logType;
            }
          });
          this.pagination.total = Number(total);
        }
      });
    },
    // 获取操作类型字典
    getOperateType() {
      getDictionary({ code: "LOGIN_OPERATER_TYPE" }).then(res => {
        if (res.success) {
          if (res.data && res.data.dictItems && res.data.dictItems.length) {
            this.operateType = res.data.dictItems;
          }
        }
      });
    },
    // 获取操作状态字典
    getOperateStatus() {
      getDictionary({ code: "LOG_OPERATER_STATUS" }).then(res => {
        if (res.success) {
          if (res.data && res.data.dictItems && res.data.dictItems.length) {
            this.operateStatus = res.data.dictItems;
          }
        }
      });
    },
    // 格式化操作方式列
    transLogType(type) {
      for (let i = 0; i < this.operateType.length; i++) {
        if (this.operateType[i].dictValue === type) {
          return this.operateType[i].dictLabel;
        }
      }
    },
    // 格式化操作状态数据
    transStatus(status) {
      if (status === "SUCCEED") {
        return "成功";
      } else {
        return "失败";
      }
    },
    // 显示日志详情数据
    handleShowLogsDetails(val) {
      if (val.logType) {
        val.logType = this.transLogType(val.logType);
      }
      if (val.requestState) {
        val.requestState = this.transStatus(val.requestState);
      }
      this.logDetails = val;
      this.detailsFlag = true;
    },
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1;
      this.startSearch();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.startSearch();
    },
    // 页数改变
    handleCurrentChange(val) {
      this.current = val;
      this.startSearch();
    },
    handleUpdateList() {
      this.startSearch();
    },
    // 重置参数，只是单纯重置参数，不走查询
    handleResetSearch() {
      this.searchForm = initSearchParams();
      this.startSearch();
    },

    getTree() {
      const parmas = {
        parseToTree: true
      };
      userApi.getOrgList(this.tenantId, parmas).then(res => {
        const { data } = res || {};
        if (data && data.length !== 0) {
          this.departmentUuid = data.id;
        }
      });
    },
    userchange(val) {
      if (val) {
        this.$set(this.searchForm, "userUuid", val.id);
        this.$set(this.searchForm, "userName", val.displayName);
      } else {
        this.searchForm.userUuid = "";
        this.searchForm.userName = "";
      }
    },
    getUserPageList() {
      if (this.departmentUuid) {
        const parmas = {
          page: this.userPagination.pageNum,
          size: this.userPagination.pageSize,
          orgId: this.departmentUuid,
          search: this.searchUserFormValue
        };
        userApi.getUserList(parmas).then(res => {
          if (res.success) {
            const { data } = res;
            if (data) {
              const { records = [], total = 0 } = data;
              if (this.userPagination.pageNum === 1) {
                this.userTableData = [];
              }
              this.userTableData = [...this.userTableData, ...records];
              this.userPagination.total = Number(total);
            }
          }
        });
      }
    },
    userLoadMore() {
      const { pageNum, pageSize } = this.userPagination;
      const totalPage = Math.ceil(this.userPagination.total / this.userPagination.pageSize);
      const data = this.userTableData.filter(o => !o.hidden);
      if (data.length === pageNum * pageSize && pageNum < totalPage) {
        this.userPagination.pageNum++;
        this.getUserPageList();
      }
    },
    userRemoteMethod(query) {
      if (query !== "") {
        this.searchUserFormValue = query;
      } else {
        this.searchUserFormValue = "";
      }
      this.userPagination.pageNum = 1;
      this.userTableData = [];
      this.getUserPageList();
    },
    userFocus(val) {
      if (val) {
        this.userPagination.pageNum = 1;
        this.searchUserFormValue = "";
        this.userTableData = [];
        this.getUserPageList();
      }
    }
  }
};
</script>

<style  lang="scss" scoped>
.padding24 {
  padding: 24px 24px 0;
}
.content-wrap {
  background: #fff;
  margin-top: 8px;
  height: calc(100% - 90px);
}
.search {
  background: #fff;
}
.content-table-top {
  position: relative;
  margin-bottom: 24px;
  .content-table-top-export {
    position: absolute;
    top: -6px;
    right: 0px;
  }
}
.more-btn {
  width: 104px;
  height: 40px;
}
.export-btn {
  width: 128px;
  height: 40px;
}
</style>
